import template from './form_builder.html';

const formBuilder = {
  bindings: {
    updateTemplate: '<',
    template: '<',
    type: '<',
    isPreview: '<',
    notEditable: '<',
  },
  controller: bbFormBuilderCtrl,
  controllerAs: 'vm',
  template,
};

angular
  .module('bb.appointments.feedback')
  .component('bbFormBuilder', formBuilder);

bbFormBuilderCtrl.$inject = ['$scope'];

function bbFormBuilderCtrl($scope) {
  const vm = this;
  vm.$onInit = function () {
    vm.sortableOptions = {
      start: vm.startDrag,
      stop: vm.stopDrag,
      update: vm.update,
      disabled: !!vm.isPreview,
    };
    vm.tooltipText = `The following is a tool to customize the Feedback Form for this listing!
      Showing agents on your listing will get an email sent to them (above), the link in the email will bring them to this form to fill out.
      Feel free to edit the questions anyway you’d like to better suit this listing!`;
  };

  vm.addQuestion = function (question) {
    vm.template.push(question);
    $scope.$digest();
    vm.update();
  };

  vm.removeQuestion = function (index) {
    vm.template.splice(index, 1);
    $scope.$digest();
    vm.update();
  };

  vm.editQuestion = function (index, question) {
    vm.template[index] = question;
    vm.update();
  };

  // This is to solve offset issues when dragging elements when the page is scrolled;
  // Update: the offset issue seems to have been solved by 3rd party library
  // removed the logic since it creates unneeded margin when the page is scrolled
  vm.startDrag = function (ev, ui) {
    // const scrollTop = $(window).scrollTop();
    // if (scrollTop > 0) {
    //   ui.helper.css('margin-top', scrollTop);
    // }
  };

  vm.stopDrag = function (ev, ui) {
    // ui.item.css('margin-top', 0);
  };

  vm.update = function () {
    setTimeout(() => {
      vm.updateTemplate(vm.template);
    }, 0);
  };
}

export default formBuilder;
